import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none",
  viewBox: "0 0 16 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.778 4.714a.637.637 0 0 1-.9 0l-2.606-2.607-2.607 2.607a.636.636 0 1 1-.901-.9L11.821.757a.636.636 0 0 1 .901 0l3.056 3.057a.636.636 0 0 1 0 .9",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.272.783c.234 0 .424.189.424.424v11.887a.424.424 0 0 1-.849 0V1.207c0-.235.19-.424.425-.424M7.288 9.587a.637.637 0 0 1 0 .901l-3.056 3.056a.64.64 0 0 1-.902 0L.274 10.488a.637.637 0 1 1 .901-.901l2.607 2.607 2.606-2.607a.637.637 0 0 1 .9 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.782.783c.234 0 .424.189.424.424v11.887a.424.424 0 0 1-.849 0V1.207c0-.235.191-.424.425-.424",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }